import { render, staticRenderFns } from "./govdisco.vue?vue&type=template&id=0b9463ae&scoped=true"
import script from "./govdisco.vue?vue&type=script&lang=js"
export * from "./govdisco.vue?vue&type=script&lang=js"
import style0 from "./govdisco.vue?vue&type=style&index=0&id=0b9463ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b9463ae",
  null
  
)

export default component.exports